// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1Nk4W","buttons":"SendReceipts_buttons__3zaVs","email":"SendReceipts_email__uVXRi","bookApptTitle":"SendReceipts_bookApptTitle__YcuVg"};